const ENDPOINT_PAYMENT = '/secure/payment/:paymentId'
const ENDPOINT_PAYMENT_TERM = '/secure/payment/term/:termId'
const ENDPOINT_PLANNING_PAYMENT = '/secure/plannings/:paymentId/payment'
const ENDPOINT_PLANNING_PAYMENTS = '/secure/plannings/:planningId/payments'
const ENDPOINT_SERVICE_PAYMENTS = '/secure/planning-payments/:serviceId'
const ENDPOINT_CENTER_PAYMENTS = '/secure/planning-payments-center/:centerId'

export const state = () => ({})

export const mutations = {}

export const getters = {}

export const actions = {
  async fetchServicePayments({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_SERVICE_PAYMENTS.replace(':serviceId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchCenterPayments({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_CENTER_PAYMENTS.replace(':centerId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async createPayment({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(
        ENDPOINT_PLANNING_PAYMENTS.replace(':planningId', payload.planningId),
        payload.model
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async updatePlanningPayment({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.patch(
        ENDPOINT_PLANNING_PAYMENT.replace(':paymentId', payload.paymentId),
        payload.model
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async updatePayment({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.patch(
        ENDPOINT_PAYMENT.replace(':paymentId', payload.paymentId),
        payload.model
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async deletePayment({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.delete(
        ENDPOINT_PAYMENT.replace(':paymentId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async addTermPayment({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(
        ENDPOINT_PAYMENT_TERM.replace(':termId', payload.termId),
        payload.form
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  }
}
